export { StarsRating } from './lib/StarsRating'
export { ReviewsModal } from './lib/ReviewsModal'
